(function () {
  var currencyJQuery = window.jQuery;
  if (!currencyJQuery) return;

  window.$acs = currencyJQuery.fn.jquery === '2.1.1'
    ? currencyJQuery.noConflict(true)
    : currencyJQuery;
  window.mlflag1 = false;
  window.mlflag2 = false;

  if (typeof window.mlvedaInitSwitcher === 'function') {
    window.mlvedaInitSwitcher();
  }
}());
